'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var types = require('../../types.js');
var index$2 = require('./SMS/index.js');
var index$1 = require('./Email/index.js');
var index = require('./Line/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const OptIn = ({
  featureName,
  layout,
  onOptIn,
  onChange,
  channel,
  validationError,
  notificationPreferencesState,
  consumerPreferencesOptinEnabled,
  retailerMarketingOptinEnabled
}) => {
  switch (channel) {
    case types.Channels.SMS:
    case types.Channels.HIPAA_SMS:
      return /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
        featureName: featureName,
        layout: layout,
        onOptIn: onOptIn,
        onChange: onChange,
        channel: channel,
        validationError: validationError,
        notificationPreferencesState: notificationPreferencesState,
        consumerPreferencesOptinEnabled: consumerPreferencesOptinEnabled,
        retailerMarketingOptinEnabled: retailerMarketingOptinEnabled
      });
    case types.Channels.EMAIL:
    case types.Channels.HIPAA_EMAIL:
      return /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
        featureName: featureName,
        layout: layout,
        onOptIn: onOptIn,
        channel: channel,
        validationError: validationError !== undefined,
        notificationPreferencesState: notificationPreferencesState
      });
    case types.Channels.LINE:
      return /*#__PURE__*/React__default["default"].createElement(index["default"], {
        featureName: featureName,
        layout: layout,
        channel: channel,
        notificationPreferencesState: notificationPreferencesState
      });
    default:
      // TODO: Log an error?
      return null;
  }
};

exports["default"] = OptIn;
